// @flow
import React, { Component } from 'react'
import type { Node } from 'react'
import styled from 'styled-components'
import Tooltip from '../Tooltip'

const Icon = styled.span`
  font-size: ${({ isLarge }: Object) => (isLarge ? '20' : '14')}px;
`
const Content = styled.div`
  text-align: left;
  font-size: ${({ isLarge }: Object) => (isLarge ? '18' : '14')}px;
  padding: 5px;
`

type Props = {|
  content: Node,
  isRawHtml?: boolean,
  isLarge?: boolean
|}

export default class WhatIsItHint extends Component<Props> {
  render() {
    const content = this.props.content

    return (
      <Tooltip
        isInteractive
        content={
          <Content isLarge={this.props.isLarge}>
            {this.props.isRawHtml ? <div dangerouslySetInnerHTML={{ __html: content }} /> : content}
          </Content>
        }
      >
        <Icon isLarge={this.props.isLarge} className="glyphicon glyphicon-question-sign" />
      </Tooltip>
    )
  }
}
